import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import React from 'react';

type LoaderProps = {
  size?: FontAwesomeIconProps['size'];
  beating?: boolean;
};

export const Loader = ({ size = 'lg', beating }: LoaderProps) => {
  return (
    <span className={`loader ${beating ? 'beating' : ''}`}>
      <FontAwesomeIcon icon={'circle-notch'} spin size={size} />
    </span>
  );
};
